import { FC } from 'react';

import { CtaProvider } from '../CtaProvider/CtaProvider';
import { ContentfulImage } from './ContentfulImage';
import { CtaData } from './model';

type Props = {
    cta: CtaData;
    dataTest?: string;
};

export const ImageLink: FC<Props> = ({ cta, dataTest }) => {
    return (
        <CtaProvider cta={cta}>
            {({ href, target, rel, image, onClick }) =>
                href ? (
                    <a href={href} target={target} rel={rel} onClick={onClick} data-test={dataTest}>
                        <ContentfulImage
                            src={image.src}
                            alt={image.alt || ''}
                            width={image.width}
                            height={image.height}
                            style={{ maxWidth: '100%', height: 'auto' }}
                            loading="lazy"
                        />
                    </a>
                ) : (
                    <button onClick={onClick} data-test={dataTest}>
                        <ContentfulImage
                            src={image.src}
                            alt={image.alt || ''}
                            width={image.width}
                            height={image.height}
                            style={{ maxWidth: '100%', height: 'auto' }}
                            loading="lazy"
                        />
                    </button>
                )
            }
        </CtaProvider>
    );
};
